module.exports = __webpack_public_path__ + "img/LosAngelesCountyFair.ade5b5c8.jpg";